export const getPageLinkTranslation = (pageLink, translation) => {
  let pageLinkTranslation = null;
  pageLink.translations = pageLink.translations.map((itemTranslation) => {
    if (itemTranslation.language === translation.language) {
      const { title, url } = itemTranslation;
      pageLinkTranslation = {
        default: translation.default,
        language: translation.language,
        title,
        url,
      };
      return pageLinkTranslation;
    }
    return itemTranslation;
  });

  if (!pageLinkTranslation) {
    pageLinkTranslation = {
      default: translation.default,
      language: translation.language,
      title: "",
      url: "",
    };
    pageLink.translations.push(pageLinkTranslation);
  }
  return pageLinkTranslation;
};
